export default {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 18,
}
